import { useLogout } from "@/modules/auth/features/logout";
import { AccountMenu as AccountMenuView } from "@/modules/common/features/account-menu";
import { Person } from "@/modules/common/entities/person";
import { useUser } from "@/application/providers/user";

export function AccountMenu() {
  const logout = useLogout();
  const user = useUser();

  return (
    <AccountMenuView
      logout={logout}
      avatar={<Person.Avatar personId={user?.person?.id} size="large" />}
    />
  );
}
